import BackendService from 'BackendService';
import Contact from '../../../models/Contact';
import {
  AdminAssistDraft,
  DRAFT_KEY,
  PreviewAssistTranscriptMessage,
} from './veraAdminChatAssistPromptSandboxUtils';

export function syncAdminAssistPreviewPrompt(sessionId: string, value: string): Promise<void> {
  if (!value.trim()) return Promise.resolve();
  return new BackendService().saveVeraAdminAssistPreviewPrompt(sessionId, value);
}

export function syncAdminAssistPreviewIntent(sessionId: string, value: string): Promise<void> {
  if (!value.trim()) return Promise.resolve();
  return new BackendService().saveVeraAdminAssistPreviewIntent(sessionId, value);
}

export function syncAdminAssistPreviewGrounding(sessionId: string, value: string): Promise<void> {
  if (!value.trim()) return Promise.resolve();
  return new BackendService().saveVeraAdminAssistPreviewGrounding(sessionId, value);
}

export async function ensureAdminAssistPreviewSynced(
  sessionId: string,
  markdown: string,
  intentText: string,
  groundingText: string,
): Promise<void> {
  const tasks: Promise<unknown>[] = [];
  if (markdown.trim()) {
    tasks.push(syncAdminAssistPreviewPrompt(sessionId, markdown));
  }
  if (intentText.trim()) {
    tasks.push(syncAdminAssistPreviewIntent(sessionId, intentText));
  }
  if (groundingText.trim()) {
    tasks.push(syncAdminAssistPreviewGrounding(sessionId, groundingText));
  }
  if (tasks.length === 0) return;
  await Promise.all(tasks);
}

export function persistAdminAssistTranscript(
  sessionId: string,
  messages: PreviewAssistTranscriptMessage[],
): void {
  new BackendService().saveVeraAdminAssistPreviewTranscript(sessionId, messages).catch(() => {
    /* non-fatal */
  });
}

export function scheduleAdminAssistDraftSave(
  userHasEdited: boolean,
  nextMarkdown: string,
  nextIntent: string,
  nextGrounding: string,
  contact: Contact | null,
  messages: PreviewAssistTranscriptMessage[],
  debounceRef: { current: ReturnType<typeof setTimeout> | null },
): void {
  if (!userHasEdited) return;
  if (debounceRef.current) clearTimeout(debounceRef.current);
  debounceRef.current = setTimeout(() => {
    const draft: AdminAssistDraft = {
      markdown: nextMarkdown,
      intentText: nextIntent,
      groundingText: nextGrounding,
      contactId: contact?.id ?? null,
      contactLabel: contact ? `${contact.firstName} ${contact.lastName}` : null,
      transcript: messages,
      savedAt: new Date().toISOString(),
    };
    localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
  }, 1500);
}

export function saveAdminAssistCoachingSandbox(markdown: string): void {
  new BackendService().saveVeraAdminChatAssistPromptSandbox(markdown).catch(() => {
    /* non-fatal */
  });
}

export function saveAdminAssistIntentSandbox(text: string): void {
  if (!text.trim()) return;
  new BackendService().saveVeraAdminChatAssistIntentPrompt(text).catch(() => {
    /* non-fatal */
  });
}

export function clearAdminAssistDraftStorage(): void {
  localStorage.removeItem(DRAFT_KEY);
}
